export default __webpack_public_path__ + "static/media/Manrope-Medium.7466db90.ttf";